
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/region-price/[code]",
      function () {
        return require("private-next-pages/region-price/[code]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/region-price/[code]"])
      });
    }
  